import React, { useEffect, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import PremiumLoadingScreen from "../PremiumLoading/PremiumLoading";

const TokenLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useContext(AuthContext);

  useEffect(() => {
    const loginAndRedirect = async () => {
        const accessToken = searchParams.get("accessToken");
        const refreshToken = searchParams.get("refreshToken");

        if (accessToken && refreshToken && loginWithToken) {
            try {
                await loginWithToken(accessToken, refreshToken);
                navigate("/dashboard");
            } catch (error) {
                console.error("Falha no login por token:", error);
                navigate("/");
            }
        } else {
            navigate("/");
        }
    }
    loginAndRedirect();
  }, [searchParams, loginWithToken, navigate]);

  return (
    <PremiumLoadingScreen
      isLoading={true}
      message="Autenticando sessão segura..."
      progress={50}
      isDataLoaded={false}
    />
  );
};

export default TokenLogin;